import React, { useState } from "react";
import { motion } from "framer-motion";
import Heading from "../Typography/Heading";
import InteractiveText from "../Typography/InteractiveText";
import {
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_SECTION_GAP_CLASS,
} from "../../../sections/Public/shared/publicLayoutSpec";

const CustomerSupportFAQs = () => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const faqs = [
    {
      question: "How do I find a service provider?",
      answer:
        "You can browse or search for service providers using our platform's search and filter tools. Simply enter your requirements and location to see a list of available businesses.",
    },
    {
      question: "How do I contact a business?",
      answer:
        "Once you find a business that fits your needs, you can use the integrated messaging system to send them a direct inquiry or request a quote.",
    },
    {
      question: "Is there a way to review a business after using their service?",
      answer:
        "Yes, after your service is completed, you can leave a review and rating for the business to help other customers make informed decisions.",
    },
    {
      question: "What should I do if I have an issue with a service?",
      answer:
        "If you encounter any issues, you can reach out to our Help & Support team for assistance. We are here to help resolve any concerns you may have.",
    },
    // {
    //   question: "How do I manage my account and preferences?",
    //   answer:
    //     "You can manage your account details, preferences, and communication settings from your dashboard after logging in.",
    // },
  ];

  const toggleHandler = (index) => {
    if (activeIndex === index) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };

  return (
    <div id="customer-faqs" className={`tp-container-narrow mx-auto ${PUBLIC_SECTION_GAP_CLASS}`}>
      <motion.div 
        className="w-full"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={staggerContainer}
      >
        <motion.div variants={fadeInUp} transition={{ duration: 0.6, ease: "easeOut" }}>
          <Heading variant={"h2"} className={"text-offblack"}>
            Customer FAQs
          </Heading>
        </motion.div>
        
        <motion.div
          className={PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS}
          variants={fadeInUp}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className="border-t border-solid border-mediumgray"></div>
        </motion.div>

        <div className="space-y-0">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="border-b border-solid border-mediumgray"
              variants={fadeInUp}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <div
                className="flex items-center justify-between py-6 px-4 cursor-pointer transition-colors duration-200"
                onClick={() => toggleHandler(index)}
              >
                <InteractiveText variant={"FAQHeader"} className="text-offblack font-medium">
                  {faq.question}
                </InteractiveText>
                <i
                  className={`fi ${
                    activeIndex === index ? "fi-rs-angle-up" : "fi-rs-angle-down"
                  } text-base text-offblack transition-transform duration-300 ease-in-out`}
                />
              </div>
              
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  activeIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="pb-6 px-4">
                  <InteractiveText variant={"FAQAnswer"} className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </InteractiveText>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default CustomerSupportFAQs; 